import client from './client';
import {
  StakeSummary,
  StakeValidator,
  StakeVirtual,
  UserStakedDTO,
} from '../interfaces/Stake';
import { PaginationResponse } from '../interfaces';

const getStakeSummary = async (walletAddress: string) => {
  const res = await client.get<PaginationResponse<StakeSummary>>(
    `/api/stakes/summary?address=${walletAddress}`
  );

  return res.data;
};

const getStakeValidators = async (walletAddress: string) => {
  const res = await client.get<PaginationResponse<StakeValidator[]>>(
    `/api/stakes/validators?address=${walletAddress}`
  );

  return res.data;
};

const getStakeVirtuals = async (walletAddress: string) => {
  const res = await client.get<PaginationResponse<StakeVirtual[]>>(
    `/api/stakes/virtuals?populate=*&address=${walletAddress}`
  );

  return res.data;
};

const getUserStakedByVirtualUid = async (
  uid: string,
  walletAddress: string
) => {
  const res = await client.get<{ data: UserStakedDTO[] }>(
    `/api/stakes/virtual/${uid}?address=${walletAddress}`
  );

  return res.data;
};

export {
  getStakeSummary,
  getStakeValidators,
  getStakeVirtuals,
  getUserStakedByVirtualUid,
};
